import React from 'react';
import Nav from '../Nav';
import Navbar from '../Navbar';
import Footer from '../Footer/Footer';
import Vid1 from './Vid1';
import "./View.css";

function View() {
  return (
    <div>
        <div>
            <Nav />
            <Navbar />
        </div>

<div className='vid1' style={{marginTop: "8px"}}>
<Vid1 />
</div>


<div className="mt-10">
            <Footer />
            </div>
      
    </div>
  )
}

export default View;
